import { TemplateCourseFadEnum } from "pages/ferramentaAutoria/components/courses/TemplateCourse";
import { jsonProperty, Serializable, SerializationSettings } from "ts-serializable";
import { FadInformationsExclusiveCourseModel } from "./FadInformationsExclusiveCourseModel";
import { CertificacoesModel } from "models/certificacoes/CertificacoesModel";
import { FadClassesModel } from "./FadClassesModel";

export interface IFadClasseCertificado {
    codigo: number,
    certificado: CertificacoesModel,
    classesDTO: FadClassesModel[]
}

interface IFadCourses {
    codigo: number;
    certificados: IFadClasseCertificado[];
    name: string;
    description: string;
    url: string;
    filepath?: string;
    typeRedirect: string; // Assuming TipoRedirecionamentoEnum is converted to String
    template: TemplateCourseFadEnum;
    sequentialContents: boolean;
    sequentialSteps: boolean;
    isPublic: boolean;
    finished: boolean;
    hasExclusiveContent: boolean;
    informationsExclusives: FadInformationsExclusiveCourseModel[];
    ordem: number;
}

export class FadCoursesModel extends Serializable {
    @jsonProperty(Number)
    codigo: number = -1;

    
    @jsonProperty(String)
    name: string = '';
    
    @jsonProperty(String)
    description: string = '';
    
    @jsonProperty(String)
    url: string = '';
    
    @jsonProperty(String)
    filepath?: string = '';
    
    @jsonProperty(String)
    typeRedirect: string = '';
    
    @jsonProperty(String)
    template: TemplateCourseFadEnum = TemplateCourseFadEnum.Lateral;
    
    @jsonProperty(Boolean)
    sequentialContents: boolean = false;
    
    @jsonProperty(Boolean)
    sequentialSteps: boolean = false;
    
    @jsonProperty(Boolean)
    isPublic: boolean = false;
    
    @jsonProperty(Boolean)
    finished: boolean = false;
    
    @jsonProperty(Boolean)
    hasExclusiveContent: boolean = false;
    
    @jsonProperty(FadInformationsExclusiveCourseModel)
    informationsExclusives: FadInformationsExclusiveCourseModel[] = [];
    
    certificados: IFadClasseCertificado[] = [];

    @jsonProperty(Number)
    ordem: number = -1;
    
    fromJSON(json: IFadCourses, settings?: Partial<SerializationSettings>): this {
        this.codigo = json.codigo;
        this.certificados = json.certificados;
        this.name = json.name;
        this.description = json.description;
        this.url = json.url;
        this.filepath = json.filepath,
        this.typeRedirect = json.typeRedirect;
        this.template = json.template;
        this.sequentialContents = json.sequentialContents;
        this.sequentialSteps = json.sequentialSteps;
        this.isPublic = json.isPublic;
        this.finished = json.finished;
        this.hasExclusiveContent = json.hasExclusiveContent;
        this.informationsExclusives = json.informationsExclusives;
        this.ordem = json.ordem;
        return this;
    }
}